import { Stack, Text } from '@fluentui/react'
import { PricingInfo, TokenSpend } from '../../api/models'
import StatCard from '../common/StatCard'
import PerformancePanel from './PerformancePanel'
import CostTile from './CostTile'
import TokenBreakdownTable from './TokenBreakdownTable'
import { formatTokenCount } from './performanceFormat'
import { outcomeLabel } from './performanceLabels'

type TokenSpendPanelProps = {
  tokens: TokenSpend
  pricing: PricingInfo
}

const NO_TOKEN_USAGE_MESSAGE = 'No token usage recorded for this period.'

const TokenSpendPanel = ({ tokens, pricing }: TokenSpendPanelProps) => {
  if (tokens.input_tokens + tokens.output_tokens === 0) {
    return <PerformancePanel title="Token spend" isEmpty emptyMessage={NO_TOKEN_USAGE_MESSAGE} />
  }

  const byOutcome = tokens.by_outcome.map((row) => ({ ...row, label: outcomeLabel(row.label) }))

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <Text as="h2" variant="mediumPlus" styles={{ root: { margin: 0, fontWeight: 600, color: '#605e5c' } }}>
        Token spend
      </Text>
      <Stack horizontal tokens={{ childrenGap: 16 }} styles={{ root: { flexWrap: 'wrap' } }}>
        <StatCard title="Input tokens" value={formatTokenCount(tokens.input_tokens)} color="#2B3A67" />
        <StatCard title="Output tokens" value={formatTokenCount(tokens.output_tokens)} color="#496A99" />
        <CostTile cost={tokens.cost} pricing={pricing} />
      </Stack>
      <Stack horizontal tokens={{ childrenGap: 16 }} styles={{ root: { flexWrap: 'wrap' } }}>
        <TokenBreakdownTable title="By outcome" rows={byOutcome} currency={pricing.currency} />
        <TokenBreakdownTable title="By plan" rows={tokens.by_plan} currency={pricing.currency} />
        <TokenBreakdownTable title="By call site" rows={tokens.by_call_site} currency={pricing.currency} showModel />
      </Stack>
    </Stack>
  )
}

export default TokenSpendPanel
